import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=5e7c3878&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&id=5e7c3878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7c3878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7c3878')) {
      api.createRecord('5e7c3878', component.options)
    } else {
      api.reload('5e7c3878', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=5e7c3878&scoped=true&", function () {
      api.rerender('5e7c3878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Users.vue"
export default component.exports